import { render, staticRenderFns } from "./Personnels.vue?vue&type=template&id=81ebc212&"
import script from "./Personnels.vue?vue&type=script&lang=js&"
export * from "./Personnels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports